import { toast } from "react-toastify";
import CommonUtil from "utils/CommonUtil";

interface MessageProperties {
  [code: string]: string;
}

/**
 * 메시지 Repository
 */
const messageRepository = new (class MessageRepository {
  /**
   * 조회
   */
  public async get(): Promise<any> {
    return await CommonUtil.execute({
      url:"com_message"
    })
      .then((response:any) => {
        return {
          cacheSeconds: response.CACHE_SECONDS as number,
          invalidPrefix: response.INVALID_PREFIX as string | undefined | null,
          invalidSuffix: response.INVALID_SUFFIX as string | undefined | null,
          properties: response.PROPERTIES as MessageProperties
        };
      })
      .catch((error) => {
        toast.error("Message Read Fail.");
      });
  }
})();

export default messageRepository;
